{
  "resources": "VIEWERS",
  "filters": [
    {
      "key": "{{:resourceType:}}",
      "value": "{{:id:}}",
      "op": "=="
    }
  ],
  "dateRange": {
    "start": "{{:startDateTime:}}",
    "end": "{{:endDateTime:}}"
  }
}